import {config} from "./config";

export const DairyLogin = (dairyUsername, dairyPassword, callback) => {
	fetch(`${config.API_ADDR}/login`, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({dairy_login_username: dairyUsername, dairy_login_password: dairyPassword})
	})
	.then(response => {
		if(response.ok){
			return response.json()
		}else{
			return response.status
		}
	})
	.then(data => {
		callback(data)
	})
	.catch(error => {
		console.log(error)
	})
}

export const GetSamples = (reportType, reportId, fromDate, toDate, onRestrictedResponse, callback) => {
	fetch(`${config.API_ADDR}/samples/${reportType}/${reportId}/${fromDate}/${toDate}`, {
		credentials: 'include',
	})
	.then(response => {
		if(response.ok){
			return response.json()
		}else{
			//console.log()
			if(response.status === 401){
				return onRestrictedResponse()
			}
		}
	})
	.then(data => {
		callback(data)
	})
	.catch(error => {
		console.log(error)
	})
}

export const Signout = (dairyUsername, dairyId, callback) => {
	fetch(`${config.API_ADDR}/logout`, {
		method: 'POST',
			credentials: 'include',
			headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({dairy_login_username: dairyUsername, dairy_id: dairyId})
	})
	.then(data => {
		return callback(data)
	})
	.catch(error => {
		console.log(error)
	})
}